import { TextSkeleton } from '@/components/Skeleton';

import LoadingLineChart from './LoadingLineChart';
import { CHART_DIMENSIONS } from './utils';

const { BASE_WIDTH, BASE_HEIGHT } = CHART_DIMENSIONS;

interface ChartLoadingSkeletonProps {
  width?: number;
  height?: number;
}

export const ChartLoadingSkeletonPrices = () => (
  <div className="flex flex-col w-full items-start">
    <TextSkeleton
      width={140}
      height={35}
      className="mx-4 mt-3 tablet:mx-6 tablet:mt-5.5"
      lineClassName="mb-0"
    />
    <div className="flex flex-col ml-2 tablet:ml-4">
      <TextSkeleton height={18} className="mt-1 ml-2 w-40 tablet:w-85" lineClassName="mb-0" />
      <TextSkeleton height={18} className="mt-1 ml-2 w-40 tablet:hidden" lineClassName="mb-0" />
    </div>
  </div>
);

export const ChartLoadingSkeleton = ({
  width = BASE_WIDTH,
  height = BASE_HEIGHT,
}: ChartLoadingSkeletonProps) => {
  return (
    <div className="w-full rounded-2xl h-fit bg-transparent">
      <ChartLoadingSkeletonPrices />
      <div
        className="w-full relative overflow-hidden rounded-b-6 mt-2.5"
        style={{ height: `${height}px`, minHeight: `${BASE_HEIGHT}px` }}
      >
        <div className="absolute top-0 left-0 size-full">
          <LoadingLineChart width={width} height={height} />
        </div>
      </div>
      <div className="flex justify-between items-center px-4 pt-3.5 pb-6 tablet:px-6">
        <div className="flex"></div>
        <div className="flex justify-center tablet:justify-end">
          <TextSkeleton width={296} height={28} lineClassName="mb-0" />
        </div>
      </div>
    </div>
  );
};

export default ChartLoadingSkeleton;
